import React, { useEffect } from "react";
import Icon from "storybookComponents/Icon"
import ToolTip from "storybookComponents/tooltip_new";
import { Collapse } from "reactstrap";
import "./style.css";

const tooltipText = [
  "A.Community Invites Residents To Enroll",
  "B. Resident Enrolls",
  "C. Thank You email",
  "D. Friend Invite",
  "E. Resident Reward"
]

export default React.memo(({ list, onChange, onSubOptionChange }) => {
  const [selected, setSelected] = React.useState(0);
  const [selectedSubMenu, setSelectedSubMenu] = React.useState(0);

  const select = (e) => {
    if (selected !== parseInt(e.target.id)) {
      setSelectedSubMenu(0);
    }
    setSelected(parseInt(e.target.id))
    if (typeof onChange === "function") {
      onChange(parseInt(e.target.id))
    }
  }

  const subSelected = (e) => {
    setSelectedSubMenu(parseInt(e.target.id))
    if (typeof onSubOptionChange === "function") {
      onSubOptionChange(parseInt(e.target.id))
    }
  }

  const renderChildren = (children, index) => {
    return (
      <div className={`${children.active ? "list-item" : "list-item-disable"} sub-list-item ${selectedSubMenu === children.id ? 'highlight-color' : ''}`}
        id={children.id}
        onClick={children.active ? subSelected : () => { }}
        key={index}>{children.name}</div>
    )
  }

  const renderList = (btn, index) => {
    return (
      <div className={`${selected === btn.id ? 'selected' : ''}`} >

        <div className={`list-item`} id={btn.id} onClick={select}>
          <ToolTip position="bottom" text={tooltipText[index]}>
            <div id={btn.id} key={index} className={`${selected === btn.id ? 'highlight-color' : ''}`} >{btn.name}</div>
          </ToolTip>
          {
            btn.children && btn.children.length > 0 ? <Icon id={btn.id} type="icon-down-arrow" className={`${selected === btn.id ? 'icon-rotate' : ''}`} size="sm" /> : null
          }

        </div>
        <Collapse isOpen={selected == btn.id}>
          <div className="sublist-container">
            {
              (btn.children || []).map(renderChildren)
            }
          </div>
        </Collapse>
      </div >
    )
  }

  if (!list.length) return null;
  return (
    <div className="leftmenu-container">
      {
        list.map(renderList)
      }
    </div>
  )
})